import { Component, OnInit, Input } from '@angular/core';
import { IHeaderTitle } from "app/shared/models/header-title";

@Component({
    selector: 'header-title',
    templateUrl: 'header-title.component.html',
    styleUrls: ['header-title.component.css']
})
export class HeaderTitleComponent implements OnInit {
    @Input() model: IHeaderTitle;
    constructor() { }

    ngOnInit() {
    }
}
